module.exports = __webpack_public_path__ + "media/images/logo/mstile-150x150-762022ae4bf6db0d71d015104f8a0003.png";